import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useAdState } from "../../ads/hooks/useAdState";
import { usePromoContext } from "../PromoContext";
import { getIsVertical } from "../../utils";
import { useVideoDataContext } from "../VideoDataContext";
import { checkIfVideoTypeLive } from "../../utils/liveVideoUtils";
import { OrcaAdsContext } from ".";

export const OrcaAdsProvider = ({ children, config = {} }) => {
  const { promoState, setPromoState } = usePromoContext();
  const { videoData } = useVideoDataContext();
  const isVertical = getIsVertical(videoData);
  const isLive = checkIfVideoTypeLive(videoData);

  const adOptions = {
    config,
    setPromoState,
    promoState,
    isVertical,
    isLive
  };

  const {
    adState,
    setAdState,
    adSettings,
    shouldShowAds,
    transitionToAd,
    isAdsInitialized,
    isIrisReady
  } = useAdState(adOptions);

  const contextValue = useMemo(
    () => ({
      adState,
      setAdState,
      adSettings,
      shouldShowAds,
      transitionToAd,
      isAdsInitialized,
      isIrisReady
    }),
    [
      adState,
      setAdState,
      adSettings,
      shouldShowAds,
      transitionToAd,
      isAdsInitialized,
      isIrisReady
    ]
  );

  return (
    <OrcaAdsContext.Provider value={contextValue}>
      {children}
    </OrcaAdsContext.Provider>
  );
};

OrcaAdsProvider.propTypes = {
  config: PropTypes.object,
  children: PropTypes.node
};
